import React from "react";
import PropTypes from "prop-types";

import { TextButton } from "components/core/Button";
import { H4 } from "components/core/Typography";

export const AdditionalNameInputsGroup = ({ handleRemoveName, children }) => (
	<div className="additional-names-inputs-group">
		<H4>Added Reservation Name</H4>
		<div className="additional-name-inputs">{children}</div>
		<TextButton
			color="blue"
			flush
			fullWidth={false}
			onClick={handleRemoveName}
		>
			Remove Name
		</TextButton>
	</div>
);

AdditionalNameInputsGroup.propTypes = {
	children: PropTypes.node.isRequired,
	handleRemoveName: PropTypes.func.isRequired
};
